import { UploadProps } from "antd"

export const BASE_API = "https://api.твойплюс.рф"
export const BASE_API_KEY = "Bearer "

export const IS_DEV = false

export const APP_VERSION = "3.1.0"

export enum ControllerName {
  WIDGET = "/widget",
  CORE = "/core",
  GOODS = "/goods",
  USERS = "/users",
  BRANCHES = "/branches",
  BLOG = "/blog",
  LOYALTY = "/loyalty",
  TICKETS = "/tickets",
  EVENTS = "/events",
  CRM = "/crm"
}

export enum StorageKey {
  GOODS_USER = "nx_plus_goods_user",
  GOODS_AUTHED = "nx_plus_goods_authed",

  AUTHED = "nx_topgun_authed",
  USER = "nx_topgun_user",
  MAXMA_ACCOUNT = "nx_topgun_maxma_user",
  TOKEN = "nx_topgun_token",
  BRANCH_SEARCH = "nx_topgun_branch_search",
  BRANCHES = "nx_topgun_branches",
  BRANCHES_FILTERED = "nx_topgun_branches_filtered",

  REFERAL_ID = "nx_topgun_referal_id",
  TOTAL_SALE = "nx_topgun_total_sale",

  USER_LOCATION = "nx_topgun_location",

  MONTH_STATS = "nx_topgun_months_stats",
  HELLO_WINDOW = "nx_topgun_hello_window",
  NOTIFY_MODAL_AUTO_SHOWN = "nx_topgun_notify_modal_auto_shown",

  LOCK_SCREEN = "admin_lock_screen",

  SETTING_ADMIN_SIDEBAR = "nx_topgun_admin_sidebar_tgl",
  ADMIN_CRM_VIEW_TYPE = "nx_topgun_admin_crm_view_type",

  SETTING_TW = "nx_topgun_setting_tw",
  SETTING_TR = "nx_topgun_setting_tr",
  SETTING_FR = "nx_topgun_setting_fr",
  SETTING_HSL = "nx_topgun_setting_hsl",
  SETTING_DATE = "nx_topgun_setting_date",

  SETTING_HOME_EVENTS = "nx_topgun_home_events",
  SETTING_HOME_COLLABS = "nx_topgun_home_collabs",
  SETTING_FRAN_EVENTS = "nx_topgun_fran_events",
  SETTING_FRAN_COLLABS = "nx_topgun_fran_collabs",
  SETTING_VAC_SLIDER = "nx_topgun_vac_slider",
  SETTING_VAC_LIST = "nx_topgun_vac_list",
  SETTING_MAXMA_CONF = "nx_topgun_maxma_conf",

  LAST_VISIT_DATE = "nx_topgun_last_visit_date",

  LOCALE = "nx_topgun_locale",

  IS_SNOW = "nx_plus_is_snow"
}

export const getImageUploadProps = (token: string): UploadProps => {
  return {
    name: 'images',
    multiple: false,
    maxCount: 1,
    showUploadList: false,
    headers: {
      "Authorization": `Bearer ${token}`
    },
    action: `${BASE_API}/core/uploader/images`,
    onDrop(e) {
      console.log('Dropped files', e.dataTransfer.files);
    }
  }
}

export const Rates = ['Ужасно', 'Плохо', 'Нормально', 'Хорошо', 'Отлично']

export const Subs: any[] = [
  // {
  //   key: "sub1",
  //   name: "Бесплатно",
  //   name_full: "Подписка №1",
  //   sum: 0,
  //   sale: 30,
  //   points: [
  //     `<b style="font-size: 16px;">100% кешбэк всех потраченных денег за услуги в TOPGUN с момента активации и действия подписки</b>`,
  //     "C момента подключения подписки <b>максимальная скидка 30%</b> на косметику",
  //     "Скидка на продукцию: <b>до 30%</b> на весь товар бонусными рублями",
  //     // "Возможность получать <b>до 1199</b> рублей за <b>каждого</b> приглашенного друга в систему лояльности, после того, как друг <b>зарегистрировался по уникальной ссылке и подключил подписку</b>"
  //   ],
  //   dismiss: [
  //     "<b>Уведомления</b> о поступлении товара в магазин <b>в Telegram Бот</b>",
  //   ]
  // }, 
  {
    key: "sub2",
    name: "Плюс",
    name_full: "Подписка №2",
    sum: 1000,
    sale: 50,
    points: [
      "Стоимость подписки <b>возвращается</b> на бонусный счет",
      "<b>+1 серебрянный билет</b> за покупку и продление подписки",
      `<b style="font-size: 16px;">100% кешбэк всех потраченных денег за услуги в TOPGUN с момента активации и действия подписки</b>`,
      "C момента подключения подписки <b>максимальная скидка 50%</b> на косметику",
      "Скидка на продукцию: <b>до 50%</b> на весь товар бонусными рублями",
      // "Возможность получать <b>до 1199</b> рублей за <b>каждого</b> приглашенного друга в систему лояльности, после того, как друг <b>зарегистрировался по уникальной ссылке и подключил подписку</b>",
      "<b>Уведомления</b> о поступлении товара в магазин <b>в Telegram Бот</b>"
    ],
    dismiss: []
  }
]

// "grad_top", "grad_indi", 

export const getBGColor = (ix: number) => {
  let colors = ["grad_bronze", "grad_silver", "grad_gold", "grad_plat", "grad_indi", "grad_top", "grad_sig", "grad_diamond"]
  return colors[ix]
}

export const getTechProduct = (sale: number) => {
  return {
    actual_count: null,
    categories_str: "Техника",
    count: 1798,
    id: 139,
    images: "/assets/images/pucter.webp",
    images2: "/assets/images/pucter.webp",
    in_favs: 0,
    is_abs: true,
    is_best: true,
    is_subs: false,
    link_name: "any-product",
    name: `Закажи любой товар из магазинов <b>мвидео, ситилинк, эльдорадо</b> со скидкой <b>${sale}%</b>`,
    price: 15000,
    sale: 50,
    status: 1
  }
}